import { trackExperimentViewed as trackEV } from '@mc/track-event'
import { EXPERIMENT_FLAG } from '../constants'

export const trackExperimentViewed = () => {
  trackEV(EXPERIMENT_FLAG)
}
